var map = {
	"./gallery_00.jpg": 2640,
	"./gallery_01.jpg": 2641,
	"./gallery_02.jpg": 2642,
	"./gallery_03.jpg": 2643,
	"./gallery_04.jpg": 2644,
	"./gallery_05.jpg": 2645,
	"./gallery_06.jpg": 2646,
	"./gallery_07.jpg": 2647,
	"./gallery_08.jpg": 2648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2639;